module.exports = __webpack_public_path__ + "static/media/stripe.944f4639.svg";